import React from 'react';
import { Link } from 'react-router-dom';
import Icon from '../../../components/AppIcon';
import Button from '../../../components/ui/Button';

const QuickActions = () => {
  const quickActions = [
    {
      id: 'heritage-map',
      title: 'Interactive Heritage Map',
      description: 'Explore all heritage sites on an interactive map with detailed information and photos.',
      icon: 'Map',
      link: '/heritage-interactive-map',
      color: 'text-primary'
    },
    {
      id: 'tourism-offerings',
      title: 'Tourism Services',
      description: 'Find accommodation, restaurants, and local products along the trails.',
      icon: 'Building',
      link: '/tourism-offerings',
      color: 'text-accent'
    },
    {
      id: 'about-project',
      title: 'About the Project',
      description: 'Learn more about the Creative Twinning initiative and our partners.',
      icon: 'Info',
      link: '/about-project',
      color: 'text-success'
    }
  ];

  return (
    <div className="bg-muted/30 rounded-lg p-8 mt-12">
      <div className="text-center mb-8">
        <h2 className="font-heading font-semibold text-2xl text-foreground mb-2">
          Enhance Your Journey
        </h2>
        <p className="text-muted-foreground">
          Discover additional resources to make the most of your heritage trail experience
        </p>
      </div>
      <div className="grid grid-cols-1 md:grid-cols-3 gap-6">
        {quickActions?.map((action) => (
          <div key={action?.id} className="bg-card rounded-lg p-6 shadow-card card-hover">
            <div className="flex items-start gap-4">
              <div className="flex-shrink-0">
                <div className="w-12 h-12 bg-muted rounded-lg flex items-center justify-center">
                  <Icon name={action?.icon} size={24} className={action?.color} />
                </div>
              </div>
              <div className="flex-1 min-w-0">
                <h3 className="font-heading font-semibold text-base text-foreground mb-2">
                  {action?.title}
                </h3>
                <p className="text-muted-foreground text-sm leading-relaxed mb-4">
                  {action?.description}
                </p>
                <Button
                  variant="outline"
                  size="sm"
                  iconName="ArrowRight"
                  iconPosition="right"
                  asChild
                >
                  <Link to={action?.link}>
                    Explore
                  </Link>
                </Button>
              </div>
            </div>
          </div>
        ))}
      </div>
    </div>
  );
};

export default QuickActions;